import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { DonationTableQueryParamsProps } from '../DonationListTable/DonationListTable.types'

import { DonationListStatusFilterEnum } from '@percent/partner-dashboard/services/donation/donationService.types'
import { LocaleKey } from '@percent/partner-dashboard/i18n/config'

type StatusOption = {
  label: string
  values: DonationListStatusFilterEnum[]
  text: LocaleKey
}

const donationStatusOptions: StatusOption[] = [
  {
    label: 'Awaiting funds',
    values: [DonationListStatusFilterEnum.RequestedPayment, DonationListStatusFilterEnum.Active],
    text: 'status.awaitingFunds'
  },
  {
    label: 'Ready to payout',
    values: [DonationListStatusFilterEnum.Settled, DonationListStatusFilterEnum.ReceivedPayment],
    text: 'status.readyToPayout'
  },
  {
    label: 'Paid',
    values: [DonationListStatusFilterEnum.Disbursed],
    text: 'status.paid'
  }
]

export const useDonationStatusFilter = ({ queryParams, setQueryParams }: DonationTableQueryParamsProps) => {
  const { t } = useTranslation()

  const onStatusChange = useCallback(
    (selectedLabels: string[]) => {
      const selectedValues = selectedLabels.flatMap(label => {
        const option = donationStatusOptions.find(opt => opt.label === label)

        return option?.values || []
      })

      setQueryParams({
        status: selectedValues
      })
    },
    [setQueryParams]
  )

  const getSelectedLabels = selectedValues => {
    if (!selectedValues) return []

    return donationStatusOptions
      .filter(option => option.values.some(value => selectedValues.includes(value)))
      .map(option => option.label)
  }

  return {
    donationStatusOptions: donationStatusOptions.map(opt => ({
      label: t(opt.text),
      value: opt.label
    })),
    onStatusChange,
    selectedStatus: getSelectedLabels(queryParams?.status)
  }
}
